
// src/actions/saved-diaries.js

import api from './gamba-api'
import { emitAlertMessage, clearAlertMessage } from './alert-message'
import moment from 'moment'

export const SAVE_DIARY = "SAVE_DIARY"
export const SAVE_DIARY_REQUESTED = "SAVE_DIARY_REQUESTED"
export const SAVE_DIARY_COMPLETED = "SAVE_DIARY_COMPLETED"
export const SAVE_DIARY_FAILED = "SAVE_DIARY_FAILED"

export function saveDiaryRequested() {
  return {
    type: SAVE_DIARY_REQUESTED
  }
}

export function saveDiary(group_id, diary_id, category, reported_at, subject, content, upload_files, upload_videos, attach_json, mentions) {
  return function(dispatch) {
    dispatch(saveDiaryRequested())
    return (diary_id && api.put(`/diaries/${diary_id}`, {
          saved: true, category, reported_at: moment(reported_at).format('YYYY-MM-DD'), subject, content, upload_files, upload_videos, attach_json, mentions
        }) || api.post(`/diaries`, {
          group_id, category, saved: true, reported_at: moment(reported_at).format('YYYY-MM-DD'), subject, content, upload_files, upload_videos, attach_json, mentions
        }))
        .then((results)=> {
          dispatch(saveDiaryCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(saveDiaryFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function saveDiaryCompleted(results) {
  return {
    type: SAVE_DIARY_COMPLETED,
    results,
  }
}

export function saveDiaryFailed(error) {
  return {
    type: SAVE_DIARY_FAILED,
    error,
  }
}

export const CLEAR_SAVED_DIARY = "CLEAR_SAVED_DIARY"

export function clearSavedDiary() {
  return {
    type: CLEAR_SAVED_DIARY,
  }
}

export const FETCH_SAVED_DIARIES = "FETCH_SAVED_DIARIES"
export const FETCH_SAVED_DIARIES_REQUESTED = "FETCH_SAVED_DIARIES_REQUESTED"
export const FETCH_SAVED_DIARIES_COMPLETED = "FETCH_SAVED_DIARIES_COMPLETED"
export const FETCH_SAVED_DIARIES_FAILED = "FETCH_SAVED_DIARIES_FAILED"

export function fetchSavedDiariesRequested() {
  return {
    type: FETCH_SAVED_DIARIES_REQUESTED
  }
}

export function fetchSavedDiaries(group_id, user_id) {
  return function(dispatch) {
    dispatch(fetchSavedDiariesRequested())
    return api.get(`/diaries`, { group_id, user_id, saved: true, length: 20 })
        .then((results)=> {
          dispatch(fetchSavedDiariesCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(fetchSavedDiariesFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function fetchSavedDiariesCompleted(results) {
  return {
    type: FETCH_SAVED_DIARIES_COMPLETED,
    results,
  }
}

export function fetchSavedDiariesFailed(error) {
  return {
    type: FETCH_SAVED_DIARIES_FAILED,
    error,
  }
}

export const DELETE_SAVED_DIARY = "DELETE_SAVED_DIARY"
export const DELETE_SAVED_DIARY_REQUESTED = "DELETE_SAVED_DIARY_REQUESTED"
export const DELETE_SAVED_DIARY_COMPLETED = "DELETE_SAVED_DIARY_COMPLETED"
export const DELETE_SAVED_DIARY_FAILED = "DELETE_SAVED_DIARY_FAILED"

export function deleteSavedDiaryRequested() {
  return {
    type: DELETE_SAVED_DIARY_REQUESTED
  }
}

export function deleteSavedDiary(diary_id) {
  return function(dispatch) {
    dispatch(deleteSavedDiaryRequested())
    return api.delete(`/diaries/${diary_id}`, { saved: true })
        .then((results)=> {
          dispatch(deleteSavedDiaryCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(deleteSavedDiaryFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function deleteSavedDiaryCompleted(results) {
  return {
    type: DELETE_SAVED_DIARY_COMPLETED,
    results,
  }
}

export function deleteSavedDiaryFailed(error) {
  return {
    type: DELETE_SAVED_DIARY_FAILED,
    error,
  }
}

export const DELETE_ALL_SAVED_DIARY = "DELETE_ALL_SAVED_DIARY"
export const DELETE_ALL_SAVED_DIARY_REQUESTED = "DELETE_ALL_SAVED_DIARY_REQUESTED"
export const DELETE_ALL_SAVED_DIARY_COMPLETED = "DELETE_ALL_SAVED_DIARY_COMPLETED"
export const DELETE_ALL_SAVED_DIARY_FAILED = "DELETE_ALL_SAVED_DIARY_FAILED"

export function deleteAllSavedDiaryRequested() {
  return {
    type: DELETE_ALL_SAVED_DIARY_REQUESTED
  }
}

export function deleteAllSavedDiary(group_id) {
  return function(dispatch) {
    dispatch(deleteAllSavedDiaryRequested())
    return api.delete(`/diaries/saved`, { group_id })
        .then((results)=> {
          dispatch(deleteAllSavedDiaryCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(deleteAllSavedDiaryFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function deleteAllSavedDiaryCompleted(results) {
  return {
    type: DELETE_ALL_SAVED_DIARY_COMPLETED,
    results,
  }
}

export function deleteAllSavedDiaryFailed(error) {
  return {
    type: DELETE_ALL_SAVED_DIARY_FAILED,
    error,
  }
}

export const CLEAR_SAVED_DIARIES = "CLEAR_SAVED_DIARIES"

export function clearSavedDiaries() {
  return {
    type: CLEAR_SAVED_DIARIES,
  }
}



// WEBPACK FOOTER //
// ./src/actions/saved-diaries.js